import { isPc } from '@efe-activity-fe-util/core'
import fullMP4 from '../images/full.mp4'

function initlozad() {
    var observer = lozad('.lozad', {
        rootMargin: '10px 0px',
        enableAutoReload: true,
        load: function (el) {
            $(el).addClass('loaded')
        },
    })
    observer.observe()
}
initlozad()
function initVideo() {
    if (typeof window.lozad !== 'function') {
        return
    }
    var observer = window.lozad('.video-cont.video-lozad', {
        rootMargin: '10px 0px',
        enableAutoReload: true,
        load: function (el) {
            $(el).addClass('loaded')
            $('.video-cont').append(
                `<video class="video"  loop playsinline><source src="${fullMP4}"></source></video>`
            )
        },
    })
    observer.observe()
}
initVideo()

//设备判断
$(function () {
    function isIPad() {
        var navigator = window.navigator
        return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
        /* iPad OS 13 */
    }

    function isIOS() {
        var UA = navigator.userAgent
        return (
            !!UA.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) ||
            /iPad|iPhone|iPod|Macintosh/.test(UA) ||
            isIPad()
        )
    }
    if (isIOS()) {
        $(
            '.btn-ios,.pop-btn-ios,.ios,.btn-store-ios,.pop-pangle-btn-ios'
        ).show()
        $('.btn-gp,.pop-btn-gp,.gp,.btn-store-gp,.pop-pangle-btn-gp').hide()
        requestAnimationFrame(() => {
            document.body.style.display = 'none'
            document.body.offsetHeight // 强制 reflow
            document.body.style.display = ''
        })
    } else {
        $(
            '.btn-ios,.pop-btn-ios,.ios,.btn-store-ios,.pop-pangle-btn-ios'
        ).hide()
        $('.btn-gp,.pop-btn-gp,.gp,.btn-store-gp,.pop-pangle-btn-gp').show()
    }
})
$(document).ready(function () {
    if (isPc()) {
        return
    }
    var screen_h = $('.container1').height()
    var clientHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight
    if (clientHeight < screen_h) {
        $('.reward').css({
            top: clientHeight + 'px',
            transform: 'translateY(-100%)',
        })
    }
})
$(document).ready(function () {
    var screen_h1 = $('.container1').height()
    var screen_h2 = $('.container2').height()
    var screen_h3 = $('.container3').height()
    var screen_h4 = $('.container4').height()
    var screen_h5 = $('.container5').height()
    var t_h = screen_h1 + screen_h2 + screen_h3 + screen_h4
    storeScroll()
    $(window).scroll(storeScroll)
    function storeScroll() {
        var scrollTop = $(window).scrollTop()
        if (scrollTop >= screen_h1 * 0.8) {
            $('.float-bottom').addClass('fix')
        }
        if (scrollTop < screen_h1 * 0.8) {
            $('.float-bottom').removeClass('fix')
        }

        if (scrollTop >= t_h * 0.88) {
            $('.float-bottom').removeClass('fix')
        }
    }
})

$(document).ready(function () {
    $('.video-cont').trigger('pause')
    $('.video-cont').addClass('pause')

    $('.video-box').on('click', '.video-cont', function () {
        if ($(this).hasClass('pause')) {
            $('.video').trigger('play')
            $('.btn-play').hide()
            $('.btn-pause').show()
            setTimeout(function () {
                $('.btn-pause').hide()
            }, 1000)

            $(this).removeClass('pause')
            $(this).addClass('play')
        } else {
            $('.video').trigger('pause')

            $('.btn-play').show()

            $(this).removeClass('play')
            $(this).addClass('pause')
        }
    })
})

//獎勵達標
// jQuery(document).ready(function ($) {
//     var total = 52000
//     $('.sub-num').html(FormatNum(total))
//     addAnimate()

//     function addAnimate() {
//         if (total >= 50000) {
//             $('.cleared1').show()
//             $('.finsh-line').addClass('finsh1')
//             $('.finsh-dot').addClass('step1')
//         }
//         if (total >= 100000) {
//             $('.cleared2').show()
//             $('.finsh-line').removeClass('finsh1').addClass('finsh2')

//             $('.finsh-dot').removeClass('step1').addClass('step2')
//         }
//         if (total >= 200000) {
//             $('.cleared3').show()
//             $('.finsh-line').removeClass('finsh2').addClass('finsh3')
//             $('.finsh-dot').removeClass('step2').addClass('step3')
//         }
//         if (total >= 300000) {
//             $('.cleared4').show()
//             $('.finsh-line').removeClass('finsh3').addClass('finsh4')
//             $('.finsh-dot').removeClass('step3').addClass('step4')
//         }
//         if (total >= 777777) {
//             $('.cleared5').show()
//             $('.finsh-line').removeClass('finsh4').addClass('finsh5')
//             $('.finsh-dot').removeClass('step4').addClass('step5')
//             $('.progress-bar').addClass('finsh-on')
//         }
//     }
// })

function FormatNum(nStr) {
    nStr += ''
    x = nStr.split('.')
    x1 = x[0]
    x2 = x.length > 1 ? '.' + x[1] : ''
    var rgx = /(\d+)(\d{3})/
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2')
    }
    return x1 + x2
}

//頂部導航
$(document).ready(function () {
    $('.btn-menu').bind('click', function () {
        if ($(this).hasClass('cur')) {
            $('.btn-menu').removeClass('cur')
            $('.content-box').hide()
        } else {
            $(this).addClass('cur'), $('.content-box').fadeIn(300)
        }
    }),
        $('.content-box').bind('click', function () {
            $('.btn-menu').removeClass('cur')
            $('.content-box').hide()
        })

    navScroll()
    $(window).scroll(navScroll)

    function navScroll() {
        var scrollTop = $(window).scrollTop()
        if (scrollTop >= 10) {
            $('.content-box').hide()
            $('.btn-menu').removeClass('cur')
        }
    }
})

//弹窗
$(document).ready(function () {
    $('.btn-rule').on('click', function () {
        $('.pop-rule').bPopup()
    })
})

//菜單欄
$(document).ready(function () {
    var $divs = $('.main>div')
    var $dLis = $('.content-item')
    funScroll()
    $(window).scroll(funScroll)

    function funScroll() {
        var top = $(document).scrollTop()
        $divs.each(function (index) {
            var $divObj = $(this)
            var thisTop = $divObj.offset().top - 200
            if (top >= thisTop) {
                var $activeObj = $dLis.find('.active')
                if ($dLis[index] && $($dLis[index]) != $activeObj) {
                    $($dLis[index])
                        .addClass('active')
                        .siblings()
                        .removeClass('active')
                }
            }
        })
    }
    $dLis.click(function () {
        $(this).addClass('active').siblings().removeClass('active')
        var index = $dLis.index(this)
        $('html,body').animate(
            {
                scrollTop: $($divs[index]).offset().top,
            },
            300
        )
    })
})

var swiper1 = new Swiper('.intro-container', {
    centeredSlides: true,
    loop: true,
    fadeEffect: {
        crossFade: true,
    },
    autoplay: {
        disableOnInteraction: false,
    },
    pagination: {
        el: '.intro-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.intro-next',
        prevEl: '.intro-prev',
    },
    on: {
        init: function (swiper) {
            initlozad()
        },
    },
})

var swiper2 = new Swiper('.role-container', {
    paginationClickable: true,
    loop: true,
    autoplay: {
        delay: 3000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
    },
    effect: 'fade',

    on: {
        init: function (swiper) {
            initlozad()
        },
        transitionStart: function () {
            requestAnimationFrame(() => {
                $('.role-pic').hide()
                $('.role-txt').hide()
                $('.swiper-slide-active').find('.role-pic').addClass('roleshow')
                $('.swiper-slide-active').find('.role-txt').addClass('txtshow')
                $('.swiper-slide-active').find('.role-pic').show()
                $('.swiper-slide-active').find('.role-txt').show()
            })
        },
    },

    pagination: {
        clickable: true,
        el: '.role-pagination',
    },
    navigation: {
        nextEl: '.role-next',
        prevEl: '.role-prev',
    },
})

$(() => {
    $('.float-bottom-store').attr('data-hash', 2)

    const screen_h1 = $('.container1').height()
    const screen_h2 = $('.container2').height()
    const screen_h3 = $('.container3').height()
    const screen_h4 = $('.container4').height()
    const screen_h5 = $('.container5').height()
    const heights = [screen_h1, screen_h2, screen_h3, screen_h4, screen_h5]

    const updateHash = () => {
        const scrollTop = $(window).scrollTop()
        let index = 0

        for (let i = 0, accHeight = 0; i < heights.length; i++) {
            const height = heights[i]

            index = i + 1
            if (scrollTop < accHeight + height * 0.6) {
                break
            }

            accHeight += height
        }

        if (index > 1) {
            $('.float-bottom-store').attr('data-hash', index)
        } else {
            $('.float-bottom-store').attr('data-hash', 2)
        }
    }

    updateHash()

    $(window).scroll(() => {
        updateHash()
    })
})
